export default __webpack_public_path__ + "static/media/bin-tips.e16d8c38.svg";